/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Remind_EyebrowInputs */

const en_portal_remind_eyebrow = /** @type {(inputs: Portal_Remind_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reminders`)
};

const pl_portal_remind_eyebrow = /** @type {(inputs: Portal_Remind_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przypomnienia`)
};

/**
* | output |
* | --- |
* | "Reminders" |
*
* @param {Portal_Remind_EyebrowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_remind_eyebrow = /** @type {((inputs?: Portal_Remind_EyebrowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Remind_EyebrowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_remind_eyebrow(inputs)
	return en_portal_remind_eyebrow(inputs)
});